import React from 'react';
import { component_tool, utils_tool } from '@/tool';
import { WizTableForm } from '@/containers/common';
import { Descriptions } from 'antd'

let { WizModal, WizCard, WizPopover, WizTooltip, WizRate } = component_tool;
let { $$, checkStrLength } = utils_tool;
import moment from 'moment';
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm') : '';
}

//配置项
let componentName = 'comment';
let ref;
let refAlone;
let refLookDetail;
const columns = (data) => {
  return [
    {
      name: 'id',
      formItem: {
        type: 'hidden'
      }
    },
    {
      title: '评价内容',
      name: 'searchContent',
      dataIndex: 'searchContent',
      searchItem: {}
    },
    {
      title: '姓名',
      name: 'commentFullName',
      tableItem: {},
    },
    {
      title: '账号',
      name: 'commentUserName',
      tableItem: {},
    },
    {
      title: '评价内容',
      name: 'content',
      tableItem: {
        width: 260,
        render: (text) => {
          let info = text
          if (info.length > 20) {
            info = text.substring(0,20)+'...'
          }
          return <WizTooltip title={text} placement='topLeft' >{info}</WizTooltip>
        }
      },
    },
    {
      title: '星评',
      name: 'score',
      dataIndex: 'score',
      tableItem: {
        render: (text, record) => (
          <>{ record && record.score!=null && record.score!=0 ? record.score+'星':'' }</>
        ),
      },
      dict: [
        { code: 0.5, codeName: '0.5星' },
        { code: 1, codeName: '1星' },
        { code: 1.5, codeName: '1.5星' },
        { code: 2, codeName: '2星' },
        { code: 2.5, codeName: '2.5星' },
        { code: 3, codeName: '3星' },
        { code: 3.5, codeName: '3.5星' },
        { code: 4, codeName: '4星' },
        { code: 4.5, codeName: '4.5星' },
        { code: 5, codeName: '5星' }
      ],
      searchItem: {
        type: 'select'
      },
    },
    {
      title: '手机号',
      name: 'commentMobile',
      tableItem: {},
    },
    {
      title: '是否被屏蔽',
      name: 'switchScreen',
      dict: [
        {code: 1, codeName: '是'},
        {code: 0, codeName: '否'},
      ],
      tableItem: {},
    },

    {
      title: '姓名',
      name: 'searchCommentFullName',
      dataIndex: 'searchCommentFullName',
      searchItem: {}
    },
    {
      title: '账号',
      name: 'searchCommentUserName',
      dataIndex: 'searchCommentUserName',
      searchItem: {}
    },
    /* {
      title: '证件号码',
      name: 'commentIdCard',
      tableItem: {},
    }, */
    {
      title: '状态',
      name: 'state',
      dict: [
        { code: 0, codeName: '待审核' },
        { code: 1, codeName: '审核通过' },
        { code: 2, codeName: '审核未通过' }
      ],
      tableItem: {},
      searchItem: {type: 'select'}
    },
    {
      title: '用户属性',
      name: 'commentUserType',
      dict: [
        { code: 0, codeName: '培训平台用户' },
        { code: 5, codeName: '服务商用户' },
        { code: 4, codeName: '经销商用户' },
        { code: 3, codeName: 'OEM部门用户' }
      ],
      tableItem: {},
    },
    {
      title: '评价时间',
      name: 'commentTime',
      tableItem: {
        width: 150,
        render: (text, record) => (
          <>{ record && record.commentTime ? formatterDate(record.commentTime):'' }</>
        ),
      },
    },
    {
      title: '审核人',
      name: 'reviewFullName',
      tableItem: {},
    },
    {
      title: '审核时间',
      name: 'reviewTime',
      tableItem: {
        width: 150,
        render: (text, record) => (
          <>{ record && record.reviewTime ? formatterDate(record.reviewTime):'' }</>
        ),
      },
    }
  ]
};

const _getValue = (type, key) => {
  const values = {
      state: {
          0: '待审核',
          1: '审核通过',
          2: '审核未通过'
      },
  }
  return values[type][key] || ''
}

const templateConfig = (data) => {
  const { onSelect, _btnLookUserFun, _this } = data;
  let _onSelect = (key, rows) => {
    onSelect && onSelect(key, rows);
    ref && ref.getSelectRows(rows)
  };
  let initRows = () => {
    return _this.state.selectedStudentProgramEvaluationRows
  };

  return {
    mainProps: {},
    content: {
      name: 'WizTableList',
      params: {
        columns: columns(data),
        btnAccessCheck:false,
        searchBarProps: {
          // collapse: false,
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          buttonSort: ['shieldOrUnshieldBatch', 'batchReview'],
          buttons: [
            {
              key: 'shieldOrUnshieldBatch',
              custom: true,
              params: { icon: 'export', children: '批量屏蔽', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: 'changeScreenBatch',
                  apiParams: {}
                },
                formatParams: (rows, record, filter, callback) => {
                  if (!rows?.length) {
                    wizNotice.warn('至少选择一条数据!');
                    return;
                  }
                  WizModal.confirm({
                    title: '注意',
                    content: '确认要屏蔽这些评论吗？',
                    onOk: () => {
                      callback && callback({
                        state: 1,
                        ids: rows.map(item => item.id)
                      })
                    },
                    onCancel() {
                    }
                  });
                  return null
                }
              },
              recordChangeParams: ({record, rows}) => {
                let rs = rows.filter(r => (r.state == 1 && r.switchScreen == 0 ));
                let disabled = true;
                if (rs?.length > 0 && rs.length == rows.length) {
                  disabled = false
                }
                return {disabled: disabled}
              },
            },
            {
              key: 'batchReview',
              custom: true,
              params: {children: '批量审核', type: 'primary'},
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "batchReviewPre",
                  apiParams: {}
                },
                formatParams: (rows, red, filters, callback) => {
                  let record = rows
                  let ids = record.map(r=>r.id);
                  callback && callback({ ids: ids });
                  return null
                }
              },
              recordChangeParams: ({record, rows}) => {
                let rs = rows.filter(r => r.state == 1 || r.state == 2);
                let disabled = true;
                if (rows?.length > 0) {
                  disabled = false
                  if (rs?.length > 0) {
                    disabled = true
                  }
                }
                return {disabled: disabled}
              },
            },
          ]
        },
        dataTableProps: {
          rowKey: 'id',
          selectType: 'checkbox',
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
          onSelect: _onSelect,
          rowSelection: {
            getCheckboxProps: (record) => {
              return { disabled: record['switchScreen'] !== 0 };
            },
          },
          needOnRowSelect: (record, index) => {
            return record['state'] === 1
          },
        },
        rowOperateSort: ['viewProgramEvaluation', 'lookUser', 'shieldOrUnshield'],
        rowOperateView: [
          {
            key: 'viewProgramEvaluation',
            custom: true,
            params: {  children: '查看' },
            customOnClick: {
              key: 'modal',
              params: {
                modalKey:'viewProgramEvaluation_'+new Date().getTime(),
                modalParams: {
                  title: '课程评论详情',
                  diy: (e) => {
                    e.record = Object.assign({},e.record)
                    let record = e.record
                    return(
                      <Descriptions column={1}>
                        <Descriptions.Item label="评论评分">
                          <WizRate allowHalf value={record.score} />
                        </Descriptions.Item>
                        <Descriptions.Item label="评论内容">{record.content}</Descriptions.Item>
                        <Descriptions.Item label="审核结果">{_getValue('state',record.state)}</Descriptions.Item>
                        <Descriptions.Item label="审核信息">{record.reviewReason}</Descriptions.Item>
                      </Descriptions>
                    )
                  },
                  footer:null,
                  width: 600
                }
              },
              formatParams: (rows, record, filter) => {
                return { ...record };
              }
            }
          },
          {
            key: 'lookUser',
            name: 'WizButton',
            params: {
              children: '查看任职',
              key: '_btnUser',
            },
            onClick: e => _btnLookUserFun && _btnLookUserFun(e),
          },
          {
            key: 'shieldOrUnshield',
            custom: true,
            params: {children: '屏蔽'},
            textFormat: {
              recordKey: 'switchScreen',
              dirt: {'1': '取消屏蔽', '0': '屏蔽',}
            },
            customOnClick: {
              key: 'action',
              params: {
                apiKey: 'changeScreen',
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要${
                  record['status'] === 0 ? '启用' : '禁用'
                }该评论吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      id: record['id'],
                      ...filters
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: ({record, rows}) => {
              let disabled = true;
              if (record && record.state == 1) {
                disabled = false
              }
              return {disabled: disabled}
            },
          },
        ],
        commonOperate: {
          add: false,
          delete: false,
          look: false
        }
      }
    }
  };
};

const apis = (data) => {
  const { bizIdList } = data;
  return {
    list: {
      path: `${componentName}/commentMarkDetailPageList`,
      payload: {
        key: `${componentName}@commentMarkDetailPageList`,
        apiParams: { pageNum: 1, pageSize: 10,  bizIdList,bizType: 0 }
      }
    },
    changeScreen: {
      path: `comment/changeScreen`,
      payload: {
        key: `comment@changeScreen`,
        apiParams: {}
      }
    },
    changeScreenBatch: {
      path: `comment/changeScreenBatch`,
      payload: {
        key: `comment@changeScreenBatch`,
        apiParams: {}
      }
    },
    batchReviewPre: {
      path: `comment/batchReviewPre`,
      payload: {
        key: `comment@batchReviewPre`,
        apiParams: {}
      }
    }
  }
};


let reduxTemplateConfig = (args) => {
  const { programId } = args;
  return {
    apis: apis({ bizIdList:[programId],bizType: 0}),
    componentName,
    initApiKeys: ['list'],
    keepInitApiParams: true,
    needLoading: true,
    ...args
  }
};

export { reduxTemplateConfig, templateConfig };
